import React, {useEffect, useState} from 'react';
import {message, Modal, Select} from 'antd';

import {ReactComponent as SelectArrayIcon} from 'assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from 'assets/i/arrow-up-icon.svg';
import {useInputWithFocus} from "common/hook/useInputWithFocus";
import {useAppDispatch, useAppSelector} from "common/hook";
import {SelectModeGroup} from "components/pages/test/test-inner-answer/test-add/select-mode-group/SelectModeGroup";
import {
    SelectModeStudent
} from "components/pages/test/test-inner-answer/test-add/select-mode-student/selectModeStudent";
import {groupListing} from "features/model/service/create-test/group-listing/groupListing";
import {studentListing} from "features/model/service/create-test/student-listing/studentListing";
import {optionsAvailableType} from "components/form/options/options";

import {setErrors} from "features/model/slice/create-test/add-test/responseAddTest";
import {useNavigate} from "react-router-dom";
import {fetchAddTest} from "features/model/service/test/feath-add-test/fetchAddTest";
import {createConfirmationModal} from "components/create-confirmation-modal/CreateConfirmationModal";


export const TestAddItem = () => {
    const dispatch = useAppDispatch();
    const {errors, success, data} = useAppSelector(state => state.responseAddTest)
    const [openOne, setOpenOne] = useState<boolean>(false);
    const [values, setValues] = useState({available: '1', title: ''});
    const {isFilled, handleFocus, handleBlur} = useInputWithFocus([false, false, false, false, false]);
    const navigate = useNavigate();

    const [selectedGroupIds, setSelectedGroupIds] = useState<number[]>([]);
    const [selectedStudentIds, setSelectedStudentIds] = useState<number[]>([]);

    const onClearGroups =()=> {
        setSelectedGroupIds([])
    }

    const onClearStudents =()=> {
        setSelectedStudentIds([])
    }

    const successMessageTrue = () => {
        message.success('Тест успешно создан');
    };

    useEffect(() => {
        dispatch(groupListing())
    }, [dispatch])


    useEffect(() => {
        dispatch(studentListing())
    }, [dispatch])


    const OnClickAvailableHandler = () => {
        setOpenOne(!openOne);
    };

    const handleChange = (name: string, value: string) => {
        setValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const handleGroupSelection = (selectedGroups: number[]) => {
        setSelectedGroupIds(selectedGroups);
    };

    const handleStudentSelection = (selectedStudents: number[]) => {
        setSelectedStudentIds(selectedStudents);
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const requestData = {
            title: values.title,
            available: values.available,
            selectedGroupIds,
            selectedStudentIds,
        };
        try {
            await dispatch(fetchAddTest(requestData)).unwrap();
        } catch (submitError: any) {
            message.error(
                submitError?.response?.data?.error
                || submitError?.message
                || 'Ошибка создания теста.'
            );
        }
    };

    useEffect(() => {
        if (success) {
            dispatch(setErrors({success: false, error: '', errors: {}}));
            successMessageTrue();
            navigate(`/test/test-edit/${data.id}`);
        }
    }, [success, dispatch, navigate, data.id]);


    const onClickCancelHandler = async () => {
        createConfirmationModal({
            title: 'Отменить изменения',
            content: 'Вы точно хотите отменить редактирование? Введенные данные не сохранятся.',
            onOk: async () => {
                navigate(`/test/`);
            },
        });
    };


    return (
        <form className='form' onSubmit={handleSubmit}>
            <div className="fields-row two-cols">
                <div className="field large-w">
                    <div
                        style={{width: '100%'}}
                        className={`field ${isFilled[0] ? 'filled' : ''} ${errors?.title ? 'error-field' : ''}`}>
                        <label className={`field-name ${values.title ? 'active-label' : ''}`}>Название теста</label>
                        <div className="inp-box">
                            <input
                                type="text"
                                name="speaking"
                                className="form-control has-icon datepicker"
                                value={values.title}
                                onChange={(event) => handleChange('title', event.target.value)}
                                onFocus={() => handleFocus(0)}
                                onBlur={handleBlur}
                            />
                        </div>
                    </div>
                    {errors?.title && <p className="field-error">{Array.isArray(errors.title) ? errors.title[0] : errors.title}</p>}
                </div>
                <div className="field middle-w">
                    <div className="course-type" onClick={OnClickAvailableHandler}>
                        <span className={values.available ? 'active-label' : ''}>Доступно</span>
                        <Select
                            style={{width: '100%', cursor: 'pointer'}}
                            value={values.available}
                            className="custom-select select-new"
                            onChange={(value) => handleChange('available', value)}
                            options={optionsAvailableType}
                            suffixIcon={openOne ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                            onFocus={() => handleFocus(1)}
                            onBlur={handleBlur}
                        />
                    </div>
                </div>
            </div>

            <div className="fields-row two-cols">
                {values.available === '0' && (
                    <>
                        <div className="field has-icon-inp">
                            <p className="field-title">Группы</p>
                            <SelectModeGroup onSelect={handleGroupSelection} onClearGroups={onClearGroups} setSelectedGroupIds={setSelectedGroupIds}/>
                        </div>
                        <div className="field has-icon-inp">
                            <p className="field-title">Студенты</p>
                            <SelectModeStudent onSelect={handleStudentSelection} onClearStudents={onClearStudents} setSelectedStudentIds={setSelectedStudentIds}/>
                        </div>
                    </>
                )}
            </div>

            <div className="col btns-col flexEnd">
                <button type="button"
                        className="btn secondary"
                        onClick={onClickCancelHandler}
                >
                    <span>Отменить</span>
                </button>
                <button type="submit" className="btn order2-desktop">
                    <span>Далее</span>
                </button>
            </div>
        </form>
    );
};